import React from 'react'
import moment from 'moment-timezone'

import { timezoneAbbr } from 'helpers'

import css from './style.scss'

/**
 * The live region lives here rather than in the grid so that it is present on
 * first paint — a live region injected at the same moment its content changes
 * is not announced.
 */
const CalendarMonthNav = ({ month, bounds, eventCount, onMonthChange }) => {
  const current = moment(month)
  const atStart = current.isSameOrBefore(bounds.min, 'month')
  const atEnd = current.isSameOrAfter(bounds.max, 'month')

  const shift = amount => onMonthChange(current.clone().add(amount, 'months').format('YYYY-MM'))

  return (
    <div className={css.monthNav}>
      <button
        type='button'
        className={css.monthNavButton}
        aria-label='Previous month'
        disabled={atStart}
        onClick={() => shift(-1)}
      >
        &#8249;
      </button>

      <h3 className={css.monthLabel}>{current.format('MMMM YYYY')}</h3>

      <button
        type='button'
        className={css.monthNavButton}
        aria-label='Next month'
        disabled={atEnd}
        onClick={() => shift(1)}
      >
        &#8250;
      </button>

      <span className={css.timezoneLabel}>Times shown in {timezoneAbbr()}</span>

      <div className={css.visuallyHidden} aria-live='polite' aria-atomic='true'>
        {`Showing ${current.format('MMMM YYYY')}. ${eventCount} event${eventCount === 1 ? '' : 's'}.`}
      </div>
    </div>
  )
}

CalendarMonthNav.propTypes = {
  month: React.PropTypes.object.isRequired,
  bounds: React.PropTypes.shape({
    min: React.PropTypes.object.isRequired,
    max: React.PropTypes.object.isRequired
  }).isRequired,
  eventCount: React.PropTypes.number.isRequired,
  onMonthChange: React.PropTypes.func.isRequired
}

export default CalendarMonthNav
